if (!customElements.get('byte-video-text-overlay')) {
  class ByteVideoTextOverlay extends HTMLElement {
    constructor() {
      super();

      /** @type {ReturnType<typeof window.setTimeout> | null} */
      this.rotationTimerId = null;
      /** @type {{ element: HTMLElement; durationMs: number }[]} */
      this.rotationItems = [];
      /** @type {HTMLElement[]} */
      this.overlayItems = [];
      this.activeIndex = 0;
      this.boundHandleReducedMotionChange = this.handleReducedMotionChange.bind(this);
      /** @type {MediaQueryList | null} */
      this.reducedMotionQuery = null;
    }

    connectedCallback() {
      this.#cacheElements();
      this.#startRotation();
      this.reducedMotionQuery?.addEventListener('change', this.boundHandleReducedMotionChange);
    }

    disconnectedCallback() {
      this.#clearTimer();
      this.reducedMotionQuery?.removeEventListener('change', this.boundHandleReducedMotionChange);
    }

    handleReducedMotionChange() {
      this.#clearTimer();
      this.#startRotation();
    }

    #cacheElements() {
      this.overlayItems = Array.from(this.querySelectorAll('[data-byte-video-overlay-item]')).filter(
        (element) => element instanceof HTMLElement
      );
      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    }

    #startRotation() {
      if (this.overlayItems.length === 0) return;

      this.rotationItems = this.overlayItems.map((element) => ({
        element,
        durationMs: Math.max(500, Number(element.dataset.byteVideoOverlayDurationMs) || 3000)
      }));

      if (this.reducedMotionQuery?.matches) {
        this.#setActiveIndex(0);
        return;
      }

      this.activeIndex = 0;
      this.#setActiveIndex(0);
      this.#scheduleCurrent();
    }

    /**
     * @param {number} index
     */
    #setActiveIndex(index) {
      for (let i = 0; i < this.rotationItems.length; i++) {
        const item = this.rotationItems[i];
        if (!item) continue;

        const { element } = item;
        const isActive = i === index;

        element.classList.toggle('is-active', isActive);
        element.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      }

      this.activeIndex = index;
    }

    #scheduleCurrent() {
      this.#clearTimer();

      const current = this.rotationItems[this.activeIndex];
      if (!current) return;

      this.rotationTimerId = window.setTimeout(() => {
        const nextIndex = (this.activeIndex + 1) % this.rotationItems.length;
        this.#setActiveIndex(nextIndex);
        this.#scheduleCurrent();
      }, current.durationMs);
    }

    #clearTimer() {
      if (this.rotationTimerId == null) return;

      window.clearTimeout(this.rotationTimerId);
      this.rotationTimerId = null;
    }
  }

  customElements.define('byte-video-text-overlay', ByteVideoTextOverlay);
}
